import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Typography,
  MenuItem,
  Button,
  IconButton,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import Drawer from "@mui/material/Drawer";
import axios from "axios";
import { api, get, post, put } from "../../../../utils/api";
import { companyId } from "../../../../utils/companyId";
import { useMemo } from "react";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import DeleteIcon from "@mui/icons-material/Delete";
import EditDialog from "../../../../Components/Common/EditDialog";

function AddMachinery(props) {
  const [isFormModified, setIsFormModified] = useState(false);
  const [editDialog, setEditDialog] = useState(false);
  const [alreadyMachinery, setAlreadyMachinery] = useState(false);
  const [facilities, setFacilities] = useState(["Tap to Select"]);
  const [machineCategory, setMachineCategory] = useState([]);
  const [machineTypes, setMachineTypes] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [errors, setErrors] = useState({});
  const [numberOfMachines, setNumberOfMachines] = useState(null);
  const [equipments, setEquipments] = useState([]);
  const [openMachines, setOpenMachines] = useState([]);
  const initialState = {
    company: companyId,
    location: "",
    facility: "",
    machineCategory: "",
    machineType: "",
    name: "",
    fuelType: "",
    // noOfEquipment: "",
    numberOfMachines: "",
    equipments: [],
    remark: "",
  };
  const [fromValue, setFromValue] = useState(initialState);
  const [machineryNames, setMachineryNames] = useState([]);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [selectedDeleteIndex, setSelectedDeleteIndex] = useState(null);
  const [customMachineType, setCustomMachineType] = useState("");
  const [isOtherSelected, setIsOtherSelected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [customMachineTypes, setCustomMachineTypes] = useState([]);
  const [isCustomMachineTypeVisible, setIsCustomMachineTypeVisible] =
    useState(false);

  console.log("props1s", props?.indexMachinery);

  useEffect(() => {
    get(`${api}/master/getAllFacility`)
      .then((res) => {
        setFacilities(res.data.data);
      })
      .catch((err) => {
        console.log(err, "err");
      });
  }, []);

  useEffect(() => {
    get(`/master/getAllMachineryType`)
      .then((res) => {
        if (res.data && Array.isArray(res.data.data)) {
          setMachineCategory(
            res.data.data.map((item) => ({
              id: item._id,
              name: item.type,
            }))
          );
        } else {
          console.log("Unexpected response structure:", res.data);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    if (props?.indexMachinery) {
      setFromValue(props?.indexMachinery);
    } else {
      setFromValue(initialState);
    }
  }, [props?.indexMachinery]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFromValue((prev) => ({ ...prev, [name]: value }));
    setIsFormModified(true);

    // Update fuel type and unit of fuel consumption logic
    if (name === "fuelType") {
      setEquipments((prevEquipments) =>
        prevEquipments.map((equipment) => ({
          ...equipment,
          unitOfFuelConsumption: getUnitByFuelType(value),
        }))
      );
    }

    // Validate and update errors
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };

      // Validation logic for each field
      if (name === "name" && value.trim() !== "") {
        const isDuplicate = machineryNames.includes(value.toLowerCase());
        if (isDuplicate) {
          newErrors[name] = "Machinery name already exists.";
        } else {
          delete newErrors[name];
        }
      }

      if (name === "location" && value.trim() !== "") {
        delete newErrors.location;
      }

      if (name === "facility" && value !== "Tap to Select") {
        delete newErrors.facility;
      }

      if (name === "machineCategory" && value !== "Tap to Select") {
        delete newErrors.machineCategory;
      }

      if (name === "machineType" && value !== "Tap to Select") {
        delete newErrors.machineType;
      }

      if (name === "fuelType" && value !== "Tap to Select") {
        delete newErrors.fuelType;
      }

      if (name === "numberOfMachines" && value > 0) {
        delete newErrors.numberOfMachines;
      }

      return newErrors;
    });
  };

  const handleCategoryChange = (e) => {
    const selectedId = e.target.value;
    const selectedCategory = machineCategory.find(
      (category) => category.id === selectedId
    );

    setSelectedCategory(selectedCategory?.name || "");
    setMachineTypes([]);
    setIsFormModified(true);

    if (selectedCategory) {
      get(`${api}/master/getAllMachineryType?type=${selectedCategory.name}`)
        .then((res) => {
          if (res.data && Array.isArray(res.data.data)) {
            const machineTypesWithIds = res.data.data.map((type) => ({
              id: type._id,
              name: type.name,
            }));
            setMachineTypes(machineTypesWithIds);
          } else {
            console.log("Unexpected response structure:", res.data);
          }
        })
        .catch((err) => {
          console.error("Error fetching machine types:", err);
        });
    } else {
      console.log("Selected category not found.");
    }

    setFromValue((prevState) => ({
      ...prevState,
      machineCategory: selectedId,
      machineType: "",
    }));
    validateField("machineCategory", selectedId);
  };

  const validateField = (fieldName, value) => {
    let errorMsg = "";
    if (fieldName === "machineCategory" && !value) {
      errorMsg = "Please select a machine category";
    }

    if (fieldName === "machineType" && !value) {
      errorMsg = "Please select a machine Type";
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: errorMsg,
    }));
  };

  const handleMachineTypeChange = (e) => {
    const selectedValue = e.target.value;

    if (selectedValue === "Other") {
      setIsOtherSelected(true);
      setIsFormModified(true);
      setCustomMachineType("");
      setIsCustomMachineTypeVisible(true);
      setFromValue((prevState) => ({
        ...prevState,
        machineType: "",
      }));
    } else {
      setIsOtherSelected(false);
      setIsCustomMachineTypeVisible(false); // Hide the custom machine type field if not 'Other'
      setFromValue((prevState) => ({
        ...prevState,
        machineType: selectedValue,
      }));
    }

    validateField("machineType", selectedValue);
  };

  const handleCustomMachineTypeChange = (e) => {
    setCustomMachineType(e.target.value);
    setIsFormModified(true);
  };

  const addCustomMachineType = async () => {
    if (!customMachineType) return;

    setLoading(true);
    try {
      const response = await post(`/master/addMachineryType`, {
        name: customMachineType,
        type: selectedCategory,
      });

      const newMachineType = {
        id: response?.data?.data?._id,
        name: response?.data?.data?.name,
      };

      setMachineTypes((prevTypes) => [...prevTypes, newMachineType]);
      setCustomMachineTypes((prevCustomTypes) => [
        ...prevCustomTypes,
        newMachineType,
      ]);
      setCustomMachineType(""); // Clear input after adding

      // Hide the custom machine type field after adding
      setIsCustomMachineTypeVisible(false);
    } catch (error) {
      props.setsnackOpen({
        open: true,
        message: "Type already exists",
        severity: "error",
      });
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleNoOfEquipmentChange = (e) => {
    const value = parseInt(e.target.value, 10);

    setErrors((prevErrors) => ({
      ...prevErrors,
      numberOfMachines: "",
    }));

    if (!isNaN(value) && value > 0) {
      setNumberOfMachines(value);

      const unit =
        fromValue?.fuelType === "Electricity"
          ? "KWH"
          : [
              "Diesel (100% mineral diesel)",
              "Petrol (100% mineral petrol)",
            ].includes(fromValue?.fuelType)
          ? "Liters"
          : "";

      const equipmentList = Array.from({ length: value }, (_, index) => ({
        id: `equipment-${index + 1}`,
        uniqueID: "",
        brand: "",
        model: "",
        ratedFuelConsumption: "",
        unitOfFuelConsumption: unit,
      }));

      setEquipments(equipmentList);
      setOpenMachines(Array(value).fill(false));
    } else {
      setNumberOfMachines(null);
    }
  };

  console.log("equi", equipments);

  const handleFieldChange = (index, field, value) => {
    setEquipments((prevEquipments) =>
      prevEquipments.map((equipment, idx) =>
        idx === index
          ? {
              ...equipment,
              [field]: value,
              ...(field === "fuelType" && {
                unitOfFuelConsumption: getUnitByFuelType(value),
              }),
            }
          : equipment
      )
    );
  };

  const toggleEquipment = (index) => {
    const updatedOpen = [...openMachines];
    updatedOpen[index] = !updatedOpen[index];
    setOpenMachines(updatedOpen);
  };

  const validateFields = () => {
    const newErrors = {};

    // Validate general fields
    if (!fromValue.location) {
      newErrors.location = "Location is required.";
    }
    // if (!fromValue.facility || fromValue.facility === "Tap to Select") {
    //   newErrors.facility = "Facility must be selected.";
    // }
    if (
      !fromValue.machineCategory ||
      fromValue.machineCategory === "Tap to Select"
    ) {
      newErrors.machineCategory = "Machinery Category must be selected.";
    }
    if (!fromValue.machineType || fromValue.machineType === "Tap to Select") {
      newErrors.machineType = "Machine Type must be selected.";
    }
    if (!fromValue.name) {
      newErrors.name = "Machinery Name is required.";
    }
    if (!fromValue.fuelType || fromValue.fuelType === "Tap to Select") {
      newErrors.fuelType = "Fuel Type must be selected.";
    }
    if (!numberOfMachines) {
      newErrors.numberOfMachines = "Number of Machines is required.";
    } else if (numberOfMachines <= 0) {
      newErrors.numberOfMachines = "Number of Machines must be greater than 0.";
    } else if (numberOfMachines > 0 && equipments.length === 0) {
      newErrors.equipments = "At least one equipment entry must be added.";
    }

    const uniqueIDs = equipments.map((equipment) => equipment.uniqueID);
    const duplicateUniqueIDs = uniqueIDs.reduce((acc, id, index) => {
      if (uniqueIDs.indexOf(id) !== index && id) {
        acc[id] = acc[id] || [];
        acc[id].push(index);
      }
      return acc;
    }, {});

    // Add error messages for each duplicate unique ID
    Object.values(duplicateUniqueIDs).forEach((indices) => {
      indices.forEach((index) => {
        newErrors[
          `uniqueID_${index}`
        ] = `Unique ID "${equipments[index].uniqueID}" is duplicated. Please provide a unique ID.`;
      });
    });

    // Validate individual equipment fields if numberOfMachines is greater than 0
    if (numberOfMachines > 0) {
      equipments.forEach((equipment, index) => {
        let machineryValidationMessage = "";

        // Validate each required field
        if (!equipment.uniqueID) {
          newErrors[`uniqueID_${index}`] = `Unique ID for Machinery ${
            index + 1
          } is required.`;
        }
        if (!equipment.brand) {
          newErrors[`brand_${index}`] = `Brand for Machinery ${
            index + 1
          } is required.`;
        }
        if (!equipment.model) {
          newErrors[`model_${index}`] = `Model for Machinery ${
            index + 1
          } is required.`;
        }
        if (!equipment.ratedFuelConsumption) {
          newErrors[
            `ratedFuelConsumption_${index}`
          ] = `Rated Fuel Consumption for Machinery ${index + 1} is required.`;
        } else if (isNaN(equipment.ratedFuelConsumption)) {
          newErrors[
            `ratedFuelConsumption_${index}`
          ] = `Please enter a valid numeric value for Machinery ${index + 1}.`;
        } else if (equipment.ratedFuelConsumption < 0) {
          newErrors[
            `ratedFuelConsumption_${index}`
          ] = `Please enter valid numeric value for Machinery ${index + 1}.`;
        }
        if (!equipment.unitOfFuelConsumption) {
          newErrors[
            `unitOfFuelConsumption_${index}`
          ] = `Unit of Fuel Consumption for Machinery ${
            index + 1
          } is required.`;
        }
        if (
          !equipment.uniqueID ||
          !equipment.brand ||
          !equipment.model ||
          !equipment.ratedFuelConsumption ||
          !equipment.unitOfFuelConsumption
        ) {
          machineryValidationMessage = `Please fill data of Machinery ${
            index + 1
          }.`;
          newErrors[`machinery_${index}`] = machineryValidationMessage;
        }
      });
    }
    setErrors(newErrors);
    console.log("first", newErrors);
    return Object.keys(newErrors).length === 0;
  };

  console.log("first1", errors);

  const fetchMachineryNames = async () => {
    try {
      const response = await get(`/master/getAllMachineryType`);
      const names = response.data.data.map((item) => item.name.toLowerCase());
      setMachineryNames(names);
    } catch (error) {
      console.error("Error fetching machinery names:", error);
    }
  };
  useEffect(() => {
    fetchMachineryNames();
  }, []);

  useEffect(() => {
    setFromValue({
      company: companyId,
      location: props.indexMachinery?.location ?? "",
      facility: props.indexMachinery?.facility?._id ?? "",
      fuelType: props.indexMachinery?.fuelType ?? "",
      machineCategory: props.indexMachinery?.machineCategory?._id ?? "",
      machineType: props.indexMachinery?.machineType?._id ?? "",
      equipments: props.indexMachinery?.equipments ?? [],

      numberOfMachines: props.indexMachinery?.numberOfMachines ?? "",
      name: props.indexMachinery?.name ?? "",
      remark: props.indexMachinery?.remark || "",
    });
    setEquipments(props.indexMachinery?.equipments ?? []);
    setNumberOfMachines(props.indexMachinery?.numberOfMachines ?? "");
    setAlreadyMachinery(props.indexMachinery?._id === undefined ? false : true);
  }, [props]);

  useEffect(() => {
    if (fromValue.machineCategory) {
      let selectedId = fromValue.machineCategory;
      console.log(machineCategory, "m1");
      const selectedCategory = machineCategory.find(
        (category) => category.id === selectedId
      );

      if (selectedCategory) {
        const categoryType = selectedCategory.name;
        get(`/master/getAllMachineryType?type=${categoryType}`)
          .then((res) => {
            if (res.data && Array.isArray(res.data.data)) {
              const machineTypesWithIds = res.data.data.map((type) => ({
                id: type._id,
                name: type.name,
              }));
              setMachineTypes(machineTypesWithIds);
            } else {
              console.log("Unexpected response structure:", res.data);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        console.log("No matching machine category found");
      }
    }
  }, [fromValue.machineCategory, machineCategory]);

  const resetForm = () => {
    console.log("_idddddd", props.indexMachinery);
    setNumberOfMachines(null);
    setEquipments([]);
    setErrors({});
    setCustomMachineType(""); // Clear the custom machine type
    setIsCustomMachineTypeVisible(false); // Hide the input for custom machine type
    setFromValue(initialState); // Reset the form to its initial state
  };

  const formTitle =
    props.indexMachinery?._id !== undefined
      ? "Edit Machinery"
      : "Add Machinery";

  const handleDeleteAgree = () => {
    if (selectedDeleteIndex !== null) {
      const updatedEquipments = equipments.filter(
        (_, index) => index !== selectedDeleteIndex
      );
      setEquipments(updatedEquipments);
      setSelectedDeleteIndex(null);
      setNumberOfMachines(updatedEquipments.length);
    }
    setDeleteDialog(false);
  };

  const handleDeleteClick = (index) => {
    setSelectedDeleteIndex(index);
    setDeleteDialog(true);
  };

  const handleCloseDrawer = () => {
    if (isFormModified) {
      setEditDialog(true);
    } else {
      props.setValue(false);
      props.fetchMachinery();
      resetForm();
    }
  };

  const handleExitAgree = (action) => {
    setEditDialog(false);

    if (action === "save") {
      handleSubmit();
      props.setValue(false);
      props.fetchMachinery();
      resetForm();
    } else if (action === "discard") {
      props.setValue(false);
      props.fetchMachinery();
      resetForm();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateFields()) return;

    const data = {
      date: new Date(),
      machineType: fromValue.machineType,
      machineCategory: fromValue.machineCategory,
      company: fromValue.company,
      facility: fromValue.facility,
      location: fromValue.location,
      name: fromValue.name,
      remark: fromValue.remark,
      equipments,
      fuelType: fromValue.fuelType,
      numberOfMachines: numberOfMachines || 0,
    };

    try {
      const url = alreadyMachinery
        ? `${api}/master/updateMachinery`
        : `${api}/master/addMachinery`;

      const response = alreadyMachinery
        ? await put(`${url}?id=${props.indexMachinery?._id}`, data)
        : await post(url, data);

      resetForm();
      props.setValue(false);
      props.fetchMachinery();
      props.setsnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });
    } catch (error) {
      if (
        error.response &&
        error.response.data.message === "Machinery name already exists."
      ) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          name: "Machinery name already exists.",
        }));
      } else {
        console.error("An error occurred:", error);
      }
    }
  };

  const fuelTypes = [
    "Diesel (100% mineral diesel)",
    "Petrol (100% mineral petrol)",
    "Electricity",
  ];

  const UnitOfFuel = ["Kg", "Ltr", "Kwh"];

  const uniqueMachineCategories = useMemo(() => {
    const seen = new Set();
    return machineCategory.filter((category) => {
      const duplicate = seen.has(category.name);
      seen.add(category.name);
      return !duplicate;
    });
  }, [machineCategory]);

  const handleTypeChange = (event) => {
    const selectedTypeId = event.target.value;
    setFromValue((prevState) => ({
      ...prevState,
      machineType: selectedTypeId,
    }));
  };

  //adding dyanamic

  const addEquipment = () => {
    const newEquipment = {
      uniqueID: "",
      brand: "",
      model: "",
      ratedFuelConsumption: "",
      // unitOfFuelConsumption: "",
      unitOfFuelConsumption: getUnitByFuelType(fromValue.fuelType),
    };

    setEquipments((prev) => [...prev, newEquipment]);
    setNumberOfMachines((prev) => prev + 1);
  };

  const removeEquipment = (index) => {
    setEquipments((prev) => {
      const updatedEquipments = prev.filter((_, i) => i !== index);
      setNumberOfMachines(updatedEquipments.length);
      return updatedEquipments;
    });
  };

  const getUnitByFuelType = (fuelType) => {
    if (["Electricity"].includes(fuelType)) {
      return "KWH";
    } else if (
      ["Diesel (100% mineral diesel)", "Petrol (100% mineral petrol)"].includes(
        fuelType
      )
    ) {
      return "Ltr";
    }
    return "";
  };

  const list = () => (
    <Box
      display="flex"
      gap={3}
      sx={{
        width: "26.5rem",
        height: "100vh",
        display: "flex",
        justifyContent: "space-between",
        backgroundColor: "transparent",
        overflowY: "auto",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "3%",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton
          // onClick={() => {
          //   props.setValue(false);
          //   props.fetchMachinery();
          //   resetForm();
          // }}
          onClick={handleCloseDrawer}
          sx={{ color: "black" }}
        >
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>

      <Box
        sx={{
          width: "100%",
          height: "100%",
          p: 3,
          backgroundColor: "#fff",
          overflowY: "scroll",
        }}
      >
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {formTitle}
        </Typography>

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Location
        </Typography>

        <CustomTextField
          variant="outlined"
          value={fromValue?.location}
          fullWidth
          name="location"
          placeholder="Enter Location"
          onChange={handleInputChange}
          error={!!errors.location}
          disabled={props.indexMachinery?.location === undefined ? false : true}
        />
        {errors.location && (
          <Typography variant="body2" color="#D34040">
            {errors.location}
          </Typography>
        )}

        {/* <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Facility
        </Typography>
        <CustomTextField
          select
          variant="outlined"
          // value={fromValue.facility || ""}
          value={
            fromValue.facility === "" ? "Tap to Select" : fromValue.facility
          }
          fullWidth
          name="facility"
          placeholder="Tap to Select"
          // onChange={(e) => setFromValue({ ...fromValue, facility: e.target.value })}
          onChange={handleInputChange}
          error={!!errors.facility}
          disabled={props.indexMachinery?.facility === undefined ? false : true}
          InputLabelProps={{
            style: { color: errors.facility ? "#D34040" : undefined },
          }}
        >
          <MenuItem
            value={
              fromValue.facility === ""
                ? "Tap to Select"
                : fromValue.facility.facilityName
            }
            disabled
          >
            {fromValue.facility === ""
              ? "Tap to Select"
              : fromValue.facility.facilityName}
          </MenuItem>
          {facilities.map((facility) => (
            <MenuItem key={facility._id} value={facility._id}>
              {facility.facilityName}
            </MenuItem>
          ))}
        </CustomTextField>
        {errors.facility && (
          <Typography variant="body2" color="#D34040">
            {errors.facility}
          </Typography>
        )} */}

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Machinery Category
        </Typography>
        <CustomTextField
          select
          variant="outlined"
          // value={fromValue.machineCategory}
          value={
            fromValue.machineCategory === ""
              ? "Tap to Select"
              : fromValue.machineCategory
          }
          fullWidth
          name="machineCategory"
          onChange={handleCategoryChange}
          error={!!errors.machineCategory}
          disabled={
            props.indexMachinery?.machineCategory === undefined ? false : true
          }
        >
          <MenuItem
            value={
              fromValue.machineCategory === ""
                ? "Tap to Select"
                : fromValue.machineCategory.name
            }
            disabled
          >
            {fromValue.machineCategory === ""
              ? "Tap to Select"
              : fromValue.machineCategory.name}
          </MenuItem>
          {uniqueMachineCategories.map((category) => (
            <MenuItem key={category.id} value={category.id}>
              {category.name}
            </MenuItem>
          ))}
        </CustomTextField>
        {errors.machineCategory && (
          <Typography variant="body2" color="#D34040">
            {errors.machineCategory}
          </Typography>
        )}

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Machine Type
        </Typography>

        <CustomTextField
          select
          variant="outlined"
          value={
            fromValue.machineType === ""
              ? "Tap to Select"
              : fromValue.machineType
          }
          fullWidth
          name="machineType"
          onChange={handleMachineTypeChange}
          error={!!errors.machineType}
          disabled={
            props.indexMachinery?.machineType === undefined ? false : true
          }
        >
          <MenuItem value="Tap to Select" disabled>
            Tap to Select
          </MenuItem>
          {machineTypes.map((type) => (
            <MenuItem key={type.id} value={type.id}>
              {type.name}
            </MenuItem>
          ))}
          <MenuItem value="Other">Other</MenuItem>
        </CustomTextField>

        {errors.machineType && (
          <Typography variant="body2" color="#D34040">
            {errors.machineType}
          </Typography>
        )}

        {isOtherSelected && isCustomMachineTypeVisible && (
          <Box mt={2}>
            <CustomTextField
              placeholder="Custom Machine Type"
              value={customMachineType}
              onChange={handleCustomMachineTypeChange}
              fullWidth
            />
            <Button
              variant="contained"
              color="primary"
              onClick={addCustomMachineType}
              sx={{
                backgroundColor: "#0a3f73",
                textTransform: "none",
                marginTop: "3%",
              }}
            >
              {loading ? "Loading..." : "Add"}
            </Button>
          </Box>
        )}

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Machinery Name
        </Typography>
        <CustomTextField
          variant="outlined"
          value={fromValue.name}
          fullWidth
          name="name"
          placeholder="Enter name"
          // onChange={(e) => setFromValue({ ...fromValue, name: e.target.value })}
          onChange={handleInputChange}
          error={!!errors.name}
          disabled={props.indexMachinery?.name === undefined ? false : true}
        />
        {errors.name && (
          <Typography variant="body2" color="#D34040">
            {errors.name}
          </Typography>
        )}

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          Fuel Type
        </Typography>
        <CustomTextField
          select
          variant="outlined"
          // value={fromValue.fuelType}
          value={
            fromValue.fuelType === "" ? "Tap to Select" : fromValue.fuelType
          }
          fullWidth
          name="fuelType"
          // onChange={(e) => setFromValue({ ...fromValue, fuelType: e.target.value })}
          onChange={handleInputChange}
          placeholder="Tap to Select"
          error={!!errors.fuelType}
          disabled={props.indexMachinery?.fuelType === undefined ? false : true}
          InputLabelProps={{
            style: { color: errors.fuelType ? "#D34040" : undefined },
          }}
        >
          <MenuItem
            value={
              fromValue.fuelType === "" ? "Tap to Select" : fromValue.fuelType
            }
            disabled
          >
            {fromValue.fuelType === "" ? "Tap to Select" : fromValue.fuelType}
          </MenuItem>
          {fuelTypes.map((fuel, index) => (
            <MenuItem key={index} value={fuel}>
              {fuel}
            </MenuItem>
          ))}
        </CustomTextField>
        {errors.fuelType && (
          <Typography variant="body2" color="#D34040">
            {errors.fuelType}
          </Typography>
        )}

        <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 1 }}>
          No of Machinery
        </Typography>
        <CustomTextField
          variant="outlined"
          value={numberOfMachines || ""}
          placeholder="Enter number of equipment"
          fullWidth
          onChange={handleNoOfEquipmentChange}
          disabled={props.indexMachinery?.fuelType === undefined ? false : true}
        />
        {errors.numberOfMachines && (
          <Typography variant="body2" color="#D34040">
            {errors.numberOfMachines}
          </Typography>
        )}

        {equipments.map((equipment, index) => (
          <Box key={equipment.id} sx={{ mt: 2 }}>
            {/* Equipment Title with Expand/Collapse Button */}
            <Dialog
              open={deleteDialog}
              onClose={() => setDeleteDialog(false)}
              BackdropProps={{
                style: {
                  backgroundColor: "rgba(0, 0, 0, 0.02)", // Adjust the opacity as needed (0.3 is lighter)
                },
              }}
            >
              <DialogTitle>Confirm Delete</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Do you really want to delete this entry?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setDeleteDialog(false)} color="primary">
                  Cancel
                </Button>
                <Button onClick={handleDeleteAgree} color="secondary">
                  Confirm
                </Button>
              </DialogActions>
            </Dialog>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontSize: "16px", fontWeight: "bold" }}
              >
                Machinery {index + 1}
              </Typography>
              <Box>
                <IconButton onClick={() => toggleEquipment(index)}>
                  {openMachines[index] ? (
                    <ArrowDropUpIcon />
                  ) : (
                    <ArrowDropDownIcon />
                  )}
                </IconButton>

                {/* Delete button */}
                <IconButton
                  // onClick={() => removeEquipment(index)}
                  onClick={() => handleDeleteClick(index)}
                  color="error"
                >
                  <DeleteIcon />
                </IconButton>
              </Box>
            </Box>

            {errors[`uniqueID_${index}`] && (
              <Typography variant="body2" color="#D34040">
                {`Please fill Equipment ${index + 1} form`}
              </Typography>
            )}

            {/* Collapse for Equipment Fields */}
            <Collapse in={openMachines[index]} timeout="auto" unmountOnExit>
              <Box sx={{ mt: 1 }}>
                {/* Unique ID */}
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", mt: 1 }}
                >
                  Unique ID
                </Typography>
                <CustomTextField
                  variant="outlined"
                  // value={equipment.uniqueID}
                  value={equipments[index].uniqueID}
                  placeholder="Enter ID"
                  fullWidth
                  onChange={(e) =>
                    handleFieldChange(index, "uniqueID", e.target.value)
                  }
                  error={!!errors[`uniqueID_${index}`]}
                  disabled={false}
                />
                {errors[`uniqueID_${index}`] && (
                  <Typography variant="body2" color="#D34040">
                    {errors[`uniqueID_${index}`]}
                  </Typography>
                )}

                {/* Brand */}
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", mt: 1 }}
                >
                  Brand
                </Typography>
                <CustomTextField
                  variant="outlined"
                  value={equipment.brand}
                  placeholder="Enter Brand"
                  fullWidth
                  onChange={(e) =>
                    handleFieldChange(index, "brand", e.target.value)
                  }
                  error={!!errors[`brand_${index}`]}
                  disabled={false}
                />
                {errors[`brand_${index}`] && (
                  <Typography variant="body2" color="#D34040">
                    {errors[`brand_${index}`]}
                  </Typography>
                )}

                {/* Model */}
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", mt: 1 }}
                >
                  Model
                </Typography>
                <CustomTextField
                  variant="outlined"
                  value={equipment.model}
                  placeholder="Enter Model"
                  fullWidth
                  onChange={(e) =>
                    handleFieldChange(index, "model", e.target.value)
                  }
                  error={!!errors[`model_${index}`]}
                  disabled={false}
                />
                {errors[`model_${index}`] && (
                  <Typography variant="body2" color="#D34040">
                    {errors[`model_${index}`]}
                  </Typography>
                )}

                {/* Rated Fuel Consumption */}
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", mt: 1 }}
                >
                  Rated Fuel Consumption
                </Typography>
                <CustomTextField
                  variant="outlined"
                  value={equipments[index].ratedFuelConsumption}
                  placeholder="Amount"
                  fullWidth
                  onChange={(e) =>
                    handleFieldChange(
                      index,
                      "ratedFuelConsumption",
                      e.target.value
                    )
                  }
                  error={!!errors[`ratedFuelConsumption_${index}`]}
                  disabled={false}
                />
                {errors[`ratedFuelConsumption_${index}`] && (
                  <Typography variant="body2" color="#D34040">
                    {errors[`ratedFuelConsumption_${index}`]}
                  </Typography>
                )}

                {/* Unit of Fuel Consumption */}
                <Typography
                  variant="subtitle1"
                  sx={{ fontWeight: "bold", mt: 1 }}
                >
                  Unit of Fuel Consumption
                </Typography>
                <CustomTextField
                  variant="outlined"
                  value={
                    equipment.unitOfFuelConsumption === ""
                      ? "Tap to Select"
                      : equipment.unitOfFuelConsumption
                  }
                  fullWidth
                  onChange={(e) =>
                    handleFieldChange(
                      index,
                      "unitOfFuelConsumption",
                      e.target.value
                    )
                  }
                  disabled
                >
                  <MenuItem value="Kg">Kg</MenuItem>
                  <MenuItem value="Ltr">Liters</MenuItem>
                </CustomTextField>

                {errors[`unitOfFuelConsumption_${index}`] && (
                  <Typography variant="body2" color="#D34040">
                    {errors[`unitOfFuelConsumption_${index}`]}
                  </Typography>
                )}
              </Box>
            </Collapse>
          </Box>
        ))}

        {alreadyMachinery && (
          <Button
            sx={{ mt: 2, backgroundColor: "#0a3f73" }}
            onClick={addEquipment}
            variant="contained"
          >
            Add Equipment
          </Button>
        )}

        <Typography
          variant="subtitle1"
          sx={{ fontWeight: "bold", mb: 1, mt: 2 }}
        >
          Remark
        </Typography>
        <TextField
          multiline
          rows={2}
          variant="outlined"
          fullWidth
          name="remark"
          value={fromValue.remark}
          onChange={(e) =>
            setFromValue({ ...fromValue, remark: e.target.value })
          }
          placeholder="Brief"
        />

        <Box>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <div>
      <Drawer
        sx={{
          backgroundColor: "transparent",
          "& .MuiDrawer-paper": {
            backgroundColor: "transparent",
            boxShadow: "none",
          },
        }}
        anchor="right"
        open={props.value}
        // onClose={() => {
        //   props.setValue(false);
        //   props.fetchMachinery();
        //   resetForm();
        // }}
        onClose={handleCloseDrawer}
      >
        {list()}
      </Drawer>
      {editDialog && (
        <EditDialog
          editDialog={editDialog}
          setEditDialog={setEditDialog}
          handleExitAgree={handleExitAgree}
        />
      )}
    </div>
  );
}

export default AddMachinery;

//// custom textfield

const CustomTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-root": {
    height: "40px",
  },
  "& .MuiSelect-select": {
    height: "56px",
    display: "flex",
    alignItems: "center",
  },
}));
